let autocomplete;
function initAutocomplete() {
    if (!$('#autocomplete').length || $('#autocomplete').hasClass('loaded')) return

    $('#autocomplete').addClass('loaded')
    // Create the autocomplete object, restricting the search to geographical
    // location types.
    autocomplete = new google.maps.places.Autocomplete(
        /** @type {!HTMLInputElement} */(document.getElementById('autocomplete')),
        {
            types: ['geocode'],
            componentRestrictions: {country: 'au'}
        });

    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    autocomplete.addListener('place_changed', fillInAddress);
}

function fillInAddress() {
    // Get the place details from the autocomplete object.
    const place = autocomplete.getPlace();
    let address1 = "";
    let subpremise = "";
    let postcode = "";
    let state = "";

    // Get each component of the address from the place details,
    // and then fill-in the corresponding field on the form.
    // place.address_components are google.maps.GeocoderAddressComponent objects
    // which are documented at http://goo.gle/3l5i5Mr
    for (const component of place.address_components) {
        // @ts-ignore remove once typings fixed
        const componentType = component.types[0];

        switch (componentType) {
            case "street_number": {
                address1 = `${component.long_name} ${address1}`;
                break;
            }

            case "subpremise": {
                subpremise = `Unit ${component.long_name} ${address1}`;
                break;
            }

            case "route": {
                address1 += component.short_name;
                break;
            }

            case "postal_code": {
                postcode = `${component.long_name}${postcode}`;
                break;
            }

            case "postal_code_suffix": {
                postcode = `${postcode}-${component.long_name}`;
                break;
            }
            case "locality":
                $("input[name=City]").val(component.long_name);
                break;
            case "administrative_area_level_1": {
                state = component.short_name;
                break;
            }
            case "country":
                $("input[name=Country]").val(component.long_name);
                break;
        }
    }

    $("input[name=AddressLine1]").val(address1);
    if(subpremise.length > 0) {
        $("input[name=AddressLine2]").val(subpremise);
    } else {
        $("input[name=AddressLine2]").val('');
    }
    $("input[name=PostalCode]").val(postcode);
    $("input[name=State]").val(state);

    if ($('.order-summary').length > 0) {
        let orderTotal = $('#orderTotalRaw').val();

        /* *******************************************************
        * START: Calculate shipping cost from SilverShop via ajax
        * ****************************************************** */
        let shippingCost = $('#shippingCostRaw').val();

        let addressArray = {
            'AddressLine1': address1,
            'PostalCode': postcode,
            'City': $("input[name=City]").val(),
            'State': state,
            'Country': $("input[name=Country]").val(),
        };

        let ajaxUrl = '/subscription/estimateShippingCost';
        if ($('#CheckoutForm_DeliveryForm').length) {
            ajaxUrl = '/subscription/estimateOrderShippingCost';
        }

        $.ajax({
            url: ajaxUrl,
            method: 'GET',
            data: {
                address: addressArray,
            },
            success: function (response) {
                const result = JSON.parse(response);
                if (result.success) {
                    shippingCost = result.shipping
                } else {
                    alert(result.message || 'An error occurred.');
                }
            },
            error: function (xhr) {
                console.error(xhr);
                alert('Unable to calculate shipping cost: ' + xhr.responseText);
            }
        }).then(function() {
            if(shippingCost && shippingCost > 0) {
                $('.shippingCost').html('$' + parseFloat(shippingCost).toFixed(2));
                let total = parseFloat(orderTotal) + parseFloat(shippingCost);
                $('.orderTotal').html('$' + total.toFixed(2));
            } else {
                $('.shippingCost').html('Free');
                $('.orderTotal').html('$' + parseFloat(orderTotal).toFixed(2));
            }
        });
        /* *************************
        * END: Shipping calculation
        * ************************ */
    }

    // After filling the form with address components from the Autocomplete
    // prediction, set cursor focus on the second address line to encourage
    // entry of subpremise information such as apartment, unit, or floor number.
    $("input[name=AddressLine2]").focus();
}
